import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserType } from 'types/user';
import { requiredCompanyDataCompleted } from 'utils/user';
import { CompanyType } from 'types/company';
import { AuthStateType } from './types';

const INITIAL_STATE: AuthStateType = {
  token: null,
  user: null,
  userType: null,
  hasCnpj: false,
  isAuthenticated: false,
  isLoadingAuth: true,
  company: {
    segment: '',
    id: '',
    businessName: '',
    fantasyName: '',
    abstract: '',
    amountIntervalWorkers: '',
    hasAvatar: false,
    hasCover: false,
    cellPhone: '',
    city: '',
    document: '',
    country: '',
    email: '',
    homePhone: '',
    maxMembers: 0,
    sector: '',
    state: '',
    zipCode: '',
    address: '',
    addressNumber: '',
    additionalInfo: '',
    burgh: '',
    finishedRegister: false,
    linkVideo: '',
    descriptionVideo: '',
    socialNetworks: [
      {
        active: false,
        id: '',
        createdAt: '',
        updatedAt: '',
        deletedAt: null,
        name: '',
        link: '',
        companyId: '',
        userId: ''
      }
    ],
    slug: '',
    usageContract: false,
    industry: {
      id: 0,
      name: ''
    },
    jobs: false
  },
  requiredCompanyCompleted: false
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: INITIAL_STATE,
  reducers: {
    setUserAction: (
      state,
      action: PayloadAction<{
        token: string;
        userType: 'candidate' | 'company';
        user: UserType;
        hasCnpj: boolean;
        company: CompanyType;
        requiredCompanyCompleted: boolean;
      }>
    ) => {
      const { user, token, userType, hasCnpj, company } = action.payload;
      const requiredCompanyCompleted = requiredCompanyDataCompleted(company);
      state.user = user;
      state.token = token;
      state.userType = userType;
      state.hasCnpj = hasCnpj;
      state.isAuthenticated = true;
      state.company = company;
      state.requiredCompanyCompleted = Boolean(requiredCompanyCompleted);
    },
    setIsLoadingAuthAction: (state, action: PayloadAction<boolean>) => {
      state.isLoadingAuth = action.payload;
    }
  }
});

export default authSlice.reducer;
